import NotFoundImage from "../assets/images/404-not-found.webp";
import {Link} from "react-router-dom";
import {ROOT_URL} from "../constants/global";

export default function NotFound() {
    return (
        <div className="container h-screen flex-center">
            <div className="text-center">
                <div className="max-w-[43.25rem]">
                    <img
                        alt="404 not found"
                        src={NotFoundImage}
                        className="w-full h-auto"
                    />
                </div>

                <h1 className="font-bold text-[1.375rem] text-pol-gray mt-5">فکر کنم لینکش عوض شده باشه!</h1>
                <p className="text-pol-gray mt-2">
                    <span>بین منوها صفحه مورد نظرت رو پیدا کن. یا برو </span>
                    <Link className="text-pol-main-purple" to={ROOT_URL+"/dashboard"}>صفحه اصلی</Link>
                </p>
            </div>
        </div>
    )
}
